<script lang="ts" setup>
import { computed } from "vue";
import type { PropType } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { Application } from "@/types/order/Application";
import {
  formatFromISOString,
  formatFromUnixTimestamp,
  parseISO,
  subHours,
} from "@/utils/date";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  application: {
    type: Object as PropType<Application>,
    required: true
  }
});

const displayCanStartWorkTime = computed(() => {
  return `${formatFromUnixTimestamp(
    subHours(parseISO(props.application.appliedStartWorkAt), 1),
    "MM/dd(E) HH:mm"
  )}`;
});

const displayStartWorkTime = computed(() => {
  return `${formatFromISOString(
    props.application.appliedStartWorkAt,
    "MM/dd(E) HH:mm"
  )}`;
});

const emits = defineEmits(["close"]);

function onClose() {
  emits("close");
}
</script>

<template>
  <BModal :visible="visible" hide-header hide-footer centered @hide="onClose">
    <div class="px-2 pb-2">
      <p>
        勤務開始時刻まで1時間以上あるため、出勤処理を行うことができません
      </p>
      <div class="my-4">
        <table class="w-100">
          <colgroup>
            <col class="label-cell" />
            <col />
          </colgroup>
          <tr>
            <td>勤務開始時刻</td>
            <td>{{ displayStartWorkTime }}</td>
          </tr>
          <tr>
            <td>出勤処理可能時刻</td>
            <td>{{ displayCanStartWorkTime }}</td>
          </tr>
        </table>
      </div>
      <AppButton block @click="onClose">
        確認しました
      </AppButton>
    </div>
  </BModal>
</template>

<style lang="scss" scoped>
.label-cell {
  width: 160px;
}
</style>
